import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Record(_: Props) {
  return (
    <div className={styles.record}>
      <Skeleton className={styles.input} />
    </div>
  );
}

export { Record };
